import FeatureFlagsApi from '../api/FeatureFlags';

export const FLAG_CLEANING_FEES = 'cleaning-fees';

let featureFlagsPromise = null;

// Fetched once per page load. A flag the BFF cannot resolve is treated as disabled,
// so a feature never opens by accident.
export const getFeatureFlags = () => {
    if (!featureFlagsPromise) {
        featureFlagsPromise = FeatureFlagsApi.get().catch((error) => {
            console.error('[ERROR FETCHING FEATURE FLAGS]: ', error);
            return {};
        });
    }
    return featureFlagsPromise;
};

export const isFeatureFlagEnabled = async (flagName) => (await getFeatureFlags())?.[flagName] === true;

export const resetFeatureFlags = () => {
    featureFlagsPromise = null;
};
